import React from 'react';

class FCheckbox extends React.Component {
  constructor() {
    super();

    this._createCheckbox = this._createCheckbox.bind(this);
    this._handleCheck = this._handleCheck.bind(this);
  }

  _createCheckbox(item, i) {
    var value = this.props.value || [];

    return <li key={i}>
      <input type="checkbox" className="sq-form-field"
        name={item.value}
        id={item.value}
        value={item.value}
        onChange={this._handleCheck.bind(null, item.value)}
        defaultChecked={value.indexOf(item.value) >= 0}/>

      <label htmlFor={item.value}>{item.label}</label>
    </li>;
  }

  _handleCheck(value, e) {
    var action = {
      type:       e.target.checked ? 'DISC::ADD' : 'DISC::REMOVE',
      value:      value,
      fireFilter: true
    };

    this.props.dispatchReducer(action);
  }

  render() {
    var { data } = this.props;

    return <ul>
      {data.map(function(item, i) {

        return this._createCheckbox(item, i);
      }, this)}

    </ul>;
  }
}

FCheckbox.propTypes = {
  data:            React.PropTypes.array.isRequired,
  value:           React.PropTypes.array.isRequired,
  dispatchReducer: React.PropTypes.func.isRequired
};

export default FCheckbox;
